// extracted by mini-css-extract-plugin
module.exports = {"mediumInput":"styles_mediumInput__C_VF0","errorText":"styles_errorText__XEOBm"};